export default "__VITE_ASSET__B4w88Eek__"